// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3I-B1","see-more-btn":"_3SVOT"};